import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import React from 'react'

function OnboardingForm({ onboardedClientDetails }) {
  return (
    <div className='OnboardingForm grid '>


      <h4 className='col-12 font-bold'>Company Information</h4>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.companyName} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.city} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.companyRegisteredName} />
      </div>
      <div className='col-6 flex align-items-center gap-4 px-4'>
        <Checkbox inputId='same' checked={onboardedClientDetails.onboardDetails.companyInformation.companyName === onboardedClientDetails.onboardDetails.companyInformation.companyRegisteredName} />
        <label htmlFor="same">Same as Company Name</label>
      </div>
      <div className='col-12'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.billingAddress} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.state} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.country.name} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.postCode} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.companyInformation.companyWebsite} />
      </div>

      <h4 className='col-12 font-bold pt-4'>Finance Contact Information</h4>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.financeContactInformation.personName} />
      </div>
      <div className='col-1'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.financeContactInformation.countryCode} />
      </div>
      <div className='col-5'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.financeContactInformation.phoneNumber} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.financeContactInformation.designation ?? ""} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.financeContactInformation.email} />
      </div>



      <h4 className='col-12 font-bold pt-4'>Non-Finance Contact Information</h4>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.nonFinanceContactInformation.personName} />
      </div>
      <div className='col-1'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.nonFinanceContactInformation.countryCode} />
      </div>
      <div className='col-5'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.nonFinanceContactInformation.phoneNumber} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.nonFinanceContactInformation.designation ?? ""} />
      </div>
      <div className='col-6'>
        <InputText className='w-full p-inputtext-sm' value={onboardedClientDetails.onboardDetails.nonFinanceContactInformation.email} />
      </div>


      <h4 className='col-12 font-bold pt-4'>Project Information</h4>

      <div className='col-6 flex align-items-center'>
        <p className='m-0'>Is there a Purchase Order (PO) System in Place:</p>
      </div>
      <div className='col-6 flex align-items-center gap-4'>
        <div className="flex align-items-center">
          <input type='radio' id="PO1" name="PO" value="Yes" checked={onboardedClientDetails.onboardDetails.projectInformation.isPoInPlace}  ></input>
          <label htmlFor="PO1" className="ml-2">Yes</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="PO2" name="PO" value="No" checked={!onboardedClientDetails.onboardDetails.projectInformation.isPoInPlace} ></input>
          <label htmlFor="PO2" className="ml-2">No</label>
        </div>
      </div>


      <div className='col-6 flex align-items-center'>
        <p className='m-0'>If yes, is PO mandatory on invoice:</p>
      </div>
      <div className='col-6 flex align-items-center gap-4'>
        <div className="flex align-items-center">
          <input type='radio' id="PM1" name="PM" value="Yes" checked={onboardedClientDetails.onboardDetails.projectInformation.isPoNecessary}  ></input>
          <label htmlFor="PM1" className="ml-2">Yes</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="PM2" name="PM" value="No" checked={!onboardedClientDetails.onboardDetails.projectInformation.isPoNecessary}  ></input>
          <label htmlFor="PM2" className="ml-2">No</label>
        </div>
      </div>


      <h4 className='col-12 font-bold pt-4'>Project Invoice Format</h4>

      <div className='col-6 flex align-items-center'>
        <p className='m-0'>Is Sales Contact name mandatory in invoice:</p>
      </div>
      <div className='col-6 flex align-items-center gap-4'>
        <div className="flex align-items-center">
          <input type='radio' id="Sale1" name="Sale" value="Yes" checked={onboardedClientDetails.onboardDetails.invoiceFormat.isSaleContactNameMandatory}  ></input>
          <label htmlFor="Sale1" className="ml-2">Yes</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="Sale2" name="Sale" value="No" checked={!onboardedClientDetails.onboardDetails.invoiceFormat.isSaleContactNameMandatory}  ></input>
          <label htmlFor="Sale2" className="ml-2">No</label>
        </div>
      </div>
      <div className='col-6 flex align-items-center'>
        <p className='m-0'>If PM name mandatory in invoice:</p>
      </div>
      <div className='col-6 flex align-items-center gap-4'>
        <div className="flex align-items-center">
          <input type='radio' id="PMM1" name="PMM" value="Yes" checked={onboardedClientDetails.onboardDetails.projectInformation.isPMNameMandatory}  ></input>
          <label htmlFor="PMM1" className="ml-2">Yes</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="PMM2" name="PMM" value="No" checked={!onboardedClientDetails.onboardDetails.projectInformation.isPMNameMandatory}  ></input>
          <label htmlFor="PMM2" className="ml-2">No</label>
        </div>
      </div>
      <div className='col-6 flex align-items-center'>
        <p className='m-0'>Invoice should be addressed to:</p>
      </div>
      <div className='col-6 flex align-items-center gap-4'>
        <div className="flex align-items-center">
          <input type='radio' id="Address1" name="Address" value="PM" checked={onboardedClientDetails.onboardDetails.invoiceFormat.invoiceAddressedTo.isPMSelected} ></input>
          <label htmlFor="Address1" className="ml-2">PM</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="Address2" name="Address" value="Sales" checked={onboardedClientDetails.onboardDetails.invoiceFormat.invoiceAddressedTo.isSalesSelected} ></input>
          <label htmlFor="Address2" className="ml-2">Sales</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="Address3" name="Address" value="Finance" checked={onboardedClientDetails.onboardDetails.invoiceFormat.invoiceAddressedTo.isFinanceSelected} ></input>
          <label htmlFor="Address3" className="ml-2">Finance</label>
        </div>
        <div className="flex align-items-center">
          <input type='radio' id="Address4" name="Address" value="Others" checked={onboardedClientDetails.onboardDetails.invoiceFormat.invoiceAddressedTo.others.length > 0} ></input>
          <label htmlFor="Address4" className="ml-2">Others</label>
        </div>
      </div>
      {
        onboardedClientDetails.onboardDetails.invoiceFormat.invoiceAddressedTo.others.length > 0 && <>
          <div className='col-6 flex align-items-center'>
            <p className='m-0'>Others:</p>
          </div>
          <div className="flex align-items-center">
            <InputText value={onboardedClientDetails.onboardDetails.invoiceFormat.invoiceAddressedTo.others} />
          </div>
        </>
      }

      <div className='col-12'>
        <h4 className='font-bold pt-4'>Invoice Email Format</h4>
        <span className='font-bold pt-4'>Please define recipients of any project invoice</span>
        <div className=' pt-2 flex gap-2 align-items-center '>
          <span className='font-bold'>To:</span>
          <InputText className='flex-1 ' value={onboardedClientDetails.onboardDetails.invoiceEmailFormat.emailRecipients.join(", ")} />
        </div>
        <div className=' pt-2 flex gap-2 align-items-center '>
          <span className='font-bold'>CC:</span>
          <Checkbox />
          <label >PM</label>
          <Checkbox checked={onboardedClientDetails.onboardDetails.invoiceEmailFormat.ccToOthers.length > 0} />
          <label >Others</label>
        </div>
        {

          onboardedClientDetails.onboardDetails.invoiceEmailFormat.ccToOthers.length > 0 && <div className=' pt-2 flex gap-2 align-items-center '>
            <p className='font-bold m-0'>Others:</p>
            <InputText className='flex-1' value={onboardedClientDetails.onboardDetails.invoiceEmailFormat.ccToOthers.join(", ")} />
          </div>
        }

      </div>
    </div>
  )
}

export default OnboardingForm